"use strict";
exports.__esModule = true;
exports.OpenBreakageStatuses = exports.ResolvedBreakageStatuses = exports.BreakageStatus = void 0;
var BreakageStatus;
(function (BreakageStatus) {
    BreakageStatus["Open"] = "OPEN";
    BreakageStatus["Closed"] = "CLOSED";
    BreakageStatus["ClosedCarriedForward"] = "CLOSED_CARRIED_FORWARD";
    BreakageStatus["InProcess"] = "IN_PROCESS";
    BreakageStatus["Waiting"] = "WAITING";
})(BreakageStatus = exports.BreakageStatus || (exports.BreakageStatus = {}));
exports.ResolvedBreakageStatuses = [BreakageStatus.Closed, BreakageStatus.ClosedCarriedForward];
exports.OpenBreakageStatuses = [BreakageStatus.Open, BreakageStatus.Waiting, BreakageStatus.InProcess];
